<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-information-outline
          </v-icon>
          DXEへのお知らせ
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="dxe_notifications"
              :items-per-page="-1"
              disable-pagination
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.title`]="{ item }">
                <span :title="item.title">{{ item.title | truncate(35) }}</span>
              </template>
              <!-- 種別 -->
              <template v-slot:[`item.notification_type`]="{ item }">
                <v-chip
                  small
                  label
                  dark
                  :color="item.notification_type | notification_type_chip_color"
                >
                  {{ item.notification_type | notification_type_to_label }}
                </v-chip>
              </template>
              <!-- /種別 -->
              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  color="info darken-2"
                  icon
                  @click="showButtonClickEvent(item)"
                >
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="showButtonClickEvent(item)"
                >
                  編集する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row
      v-if="hasResult"
      dense
    >
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
    <!-- /ダイアログ -->

    <notification-show-dialog
      :enable-dialog="enableNotificationDialog"
      :target-id="targetId"
      @closeEvent="closeNotificationDialog"
      @registerEvent="notificationCallback"
    />
    <!-- ダイアログ -->
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import NotificationShowDialog from './dialogs/NotificationShowDialog'
export default {
  name: 'DriverDxeNotificationIndex',
  components: {
    NotificationShowDialog
  },
  mixins: [],
  data () {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      targetId: null,
      enableNotificationDialog: false,
      tableHeaders: [
        { value: 'notification_at', text: '日時' },
        { value: 'notification_type', text: '種別' },
        { value: 'title', text: 'タイトル' },
        { text: '詳細', value: 'editable', align: 'end' },
      ],
      dxe_notifications: [],
    }
  },
  computed: {
    ...mapState('AdminDxeNotification', {
      pagination: 'pagination',
    }),
    ...mapGetters('AdminDxeNotification', [
      'hasResult'
    ]),
  },
  created() {
    this.searchDxeNotification()
  },
  methods: {
    ...mapActions('AdminDxeNotification', {
      fetchNotifications: 'index',
      deleteNotification: 'destroy'
    }),
    showButtonClickEvent (item) {
      this.targetId = item.id
      this.enableNotificationDialog = true
    },
    closeNotificationDialog () {
      this.enableNotificationDialog = false;
    },
    notificationCallback (forms) {
      this.closeNotificationDialog()
    },
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteNotification({id: item.id }).then(() =>{
            this.searchDxeNotification ()
          })
        }
      })
    },
    changePage () {
      this.searchDxeNotification()
    },
    searchDxeNotification () {
      let params = {
        page: this.page
      }
      this.fetchNotifications(params).then((content) => {
        this.dxe_notifications = content.dxe_notifications
        this.total_count = content.pagination.total_count
      })
    }
  }
}
</script>

<style scoped>

</style>
